module.exports = __webpack_public_path__ + "static/drapes-17fc06758f7b37e5f51497238fff48cb.png";